export const SUPPORT_CHAT_GET_MESSAGES_START = 'SUPPORT_CHAT_GET_MESSAGES_START';
export const SUPPORT_CHAT_GET_MESSAGES_SUCCESS = 'SUPPORT_CHAT_GET_MESSAGES_SUCCESS';
export const SUPPORT_CHAT_GET_MESSAGES_FAIL = 'SUPPORT_CHAT_GET_MESSAGES_FAIL';

export const SUPPORT_CHAT_SET_MESSAGES = 'SUPPORT_CHAT_SET_MESSAGES';

export const SUPPORT_CHAT_SET_LOCAL_MESSAGES = 'SUPPORT_CHAT_SET_LOCAL_MESSAGES';

export const SUPPORT_CHAT_GET_CHATS_START = 'SUPPORT_CHAT_GET_CHATS_START';
export const SUPPORT_CHAT_GET_CHATS_SUCCESS = 'SUPPORT_CHAT_GET_CHATS_SUCCESS';
export const SUPPORT_CHAT_GET_CHATS_FAIL = 'SUPPORT_CHAT_GET_CHATS_FAIL';

export const SUPPORT_CHAT_SET_CHATS = 'SUPPORT_CHAT_SET_CHATS';

export const SUPPORT_CHAT_SELECTED_CHAT_ITEM = 'SUPPORT_CHAT_SELECTED_CHAT_ITEM';
